import { motion } from "framer-motion";
import { useLang } from "@/i18n";

export const Process = () => {
  const { t } = useLang();
  return (
    <section id="process" data-testid="process-section" className="relative py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-16 max-w-2xl"
        >
          <div className="font-mono-alt mb-4 text-xs uppercase tracking-[0.25em] text-blue-700">
            {t.process.eyebrow}
          </div>
          <h2 className="font-display text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            {t.process.title} <span className="text-glow-gradient">{t.process.titleAccent}</span>
          </h2>
          <p className="mt-4 text-base font-normal leading-relaxed text-slate-700">{t.process.subtitle}</p>
        </motion.div>

        <div className="relative grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div className="absolute left-0 right-0 top-6 hidden h-px bg-gradient-to-r from-transparent via-blue-300 to-transparent lg:block" />
          {t.process.steps.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`process-step-${i}`}
              className="group relative"
            >
              <div className="font-display relative z-10 mb-6 inline-flex h-12 w-12 items-center justify-center rounded-full border border-blue-200 bg-white text-sm font-bold text-blue-700 transition-all duration-300 group-hover:border-blue-600 group-hover:shadow-[0_0_20px_rgba(29,78,216,0.25)]">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="font-display text-lg font-bold tracking-tight text-slate-900 sm:text-xl">
                {s.title}
              </h3>
              <p className="mt-3 text-sm font-normal leading-relaxed text-slate-700">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
